<template>
    <div class="text-input-wrapper">
        <label class="base-input text-input" :class="inputClass">
            <span v-if="showLabel" v-text="label"></span>
            <input type="text" v-model="value" :name="name" :autocomplete="autocomplete" @input="actionInput"/>
            <span v-if="showHint" class="base-input-desc" v-text="hint"></span>
        </label>
        <span v-if="showError" class="base-input-error" v-text="errorMessage"></span>
    </div>
</template>

<script>
    import BaseInput from "./BaseInput.js";

    export default {
        name: "TextInput",
        mixins: [BaseInput],
        props: {
            hint: {
                type: String,
                default: '',
            },
            name: {
                type: String,
                default: null,
            },
            autocomplete: {
                type: String,
                default: null,
            },
            hasError: {
                type: Boolean,
                default: false,
            },
            errorMessage: {
                type: String,
                default: '',
            }
        },
        computed: {
            showHint() {
                return this.hint.length > 0;
            },
            showError() {
                return this.hasError && this.errorMessage.length > 0;
            },
            inputClass() {
                return {
                    'error': this.hasError,
                    'light': !this.hasError && this.type === 'light',
                    'dark': !this.hasError && this.type === 'dark'
                };
            }
        },
        methods: {
            actionInput() {
                this.$emit('input');
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import "../scss/base-input";
</style>